"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarPanel = exports.MenuButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _push = _interopRequireDefault(require("react-burger-menu/lib/menus/push"));

var _immutable = require("redux-burger-menu/immutable");

var _redux = require("../../util/redux.js");

var _actions = require("../actions.js");

var MenuButtonComponent = function MenuButtonComponent(props) {
  var className = props.className,
      toggleSidebarMenu = props.toggleSidebarMenu;
  return /*#__PURE__*/_react["default"].createElement("button", {
    className: className,
    onClick: toggleSidebarMenu
  }, "Menu");
};

MenuButtonComponent.propTypes = {
  className: _propTypes["default"].string,
  toggleSidebarMenu: _propTypes["default"].func
};
var stateToMenuButtonProps = (0, _redux.createStateToProps)({});

var dispatchToMenuButtonProps = function dispatchToMenuButtonProps(dispatch) {
  return {
    toggleSidebarMenu: function toggleSidebarMenu() {
      return dispatch((0, _actions.toggleSidebarMenu)());
    }
  };
};

var MenuButton = (0, _reactRedux.connect)(stateToMenuButtonProps, dispatchToMenuButtonProps)(MenuButtonComponent);
exports.MenuButton = MenuButton;
var SidebarPanel = (0, _immutable.decorator)(_push["default"]);
exports.SidebarPanel = SidebarPanel;